import { stubFalse } from "lodash/fp";

import type {
  SchedulingLinkBookingWindow,
  SessionAccessLevel,
} from "@app/common/types";

import { NoRoleIcon } from "./components/styles";
import { isReadInvited } from "./UpcomingEvents/utils";
import { UserEventGroup } from "../types/eventGroupTypes";

export const BOOKING_WINDOW_DESCRIPTION: Record<
  SchedulingLinkBookingWindow,
  string
> = {
  two_weeks: "2 weeks in the future",
  one_month: "1 month in the future",
  two_months: "2 months in the future",
  three_months: "3 months in the future",
  four_months: "4 months in the future",
  five_months: "5 months in the future",
  six_months: "6 months in the future",
};

export const PREDICTED_ROLES: {
  [key in SessionAccessLevel | "no_role"]: {
    label: string;
    Icon?: typeof NoRoleIcon;
    sortValue: number;
    showIcon: (event?: UserEventGroup) => boolean;
  };
} = {
  owner: { label: "Report owner 👑", sortValue: 1, showIcon: stubFalse },
  editor: { label: "Editor", sortValue: 2, showIcon: stubFalse },
  viewer_full: { label: "Viewer", sortValue: 3, showIcon: stubFalse },
  no_access: { label: "No access", sortValue: 4, showIcon: stubFalse },
  no_role: {
    label: "No role",
    Icon: NoRoleIcon,
    showIcon: (event) => Boolean(event?.isVcOwner && !isReadInvited(event)),
    sortValue: 5,
  },
};
